import { Grid, IconButton, Paper } from "@material-ui/core";
import { ArrowBack } from '@material-ui/icons';
import EmptyPlaceholder from "components/EmptyPlaceholder/EmptyPlaceholder";
import LoadingSpinner from "components/LoadingSpinner";
import { useGetAllActivityItemsQuery } from "features/activity/activitySlice";
import ActivityTypesField from "features/activity/ActivityTypesField";
import ContractHeader from "features/clients/contracts/ContractHeader/ContractHeader";
import { useEffect, useState } from "react";
import AddRule from "../../AddRule";
import { useGetMechanicalRuleTypesQuery, useGetMechanicalsConfigQuery } from "../../mechanicalsSlice";
import Rule from './Rule';
import { lotMechanicalConfigStyles } from "./style";

const LotMechanicalConfig = ({ clientId, lotId, lotName, onClose, clientLots, mechanicalsRulesToEdit, setMechanicalsRulesToEdit }) => {
    const classes = lotMechanicalConfigStyles();

    let { data: mechanicalsRules, error: mechanicalsRulesError, isLoading: mechanicalsRulesLoading } = useGetMechanicalsConfigQuery({ clientId, lotId: !!lotId ? lotId : 0 }, { skip: !lotId });
    let { data: mechanicalsRulesTypes, error: mechanicalsRulesTypesError, isLoading: mechanicalsRulesTypesLoading } = useGetMechanicalRuleTypesQuery();
    let { data: activityItems, error: activityItemsError, isFetching: isLoadingActivityItems } = useGetAllActivityItemsQuery();

    const [filters, setFilters] = useState({})

    useEffect(() => {
        setMechanicalsRulesToEdit(mechanicalsRules?.data?.rules ?? []);
    }, [mechanicalsRules]);

    const onCancel = () => {
        setMechanicalsRulesToEdit([...mechanicalsRulesToEdit.filter(l => !l?.isNew)])
    }

    const onFilter = (filterName, filterValue, { isBundle, jsonValue } = {}) => {
        setFilters({ ...filters, [filterName]: { value: filterValue, isBundle, jsonValue } })
    }
    // Custom filter for activities and bundles
    const filteredData = mechanicalsRulesToEdit?.filter(rule => {
        const filterValue = filters?.activityId?.value;
        const isBundle = filters?.activityId?.isBundle;
        
        if (!filterValue) return true; // No filter applied
        
        if (isBundle) {
            // Filtering by bundle - match bundleId
            return rule.bundleId === filterValue;
        } else {
            // Filtering by activity - match activityId
            return rule.activityId === filterValue;
        }
    });
    
    return <Grid container direction='column' spacing={2} className={classes.lotContainer}>
        <LoadingSpinner loading={mechanicalsRulesLoading} />
        <Grid item>
            <Paper className={classes.lotName}>
                <IconButton onClick={onClose} >
                    <ArrowBack />
                </IconButton>
                {lotName}
            </Paper>
        </Grid>
        {/* <Grid item>
            {mechanicalsRules?.data?.config && <LotParams lotConfig={mechanicalsRules?.data?.config} clientId={clientId} lotId={lotId} />}
        </Grid> */}

        <Grid item justifyContent="space-between">
            <ContractHeader
                label={`Mechanical Rules (${mechanicalsRulesToEdit?.length ?? 0})`}
            />
            <AddRule
                clientId={clientId}
                lotId={lotId}
                clientLots={clientLots}
                mechanicalsRulesToEdit={mechanicalsRulesToEdit}
                setMechanicalsRulesToEdit={setMechanicalsRulesToEdit}
            />
        </Grid>
        {!!mechanicalsRulesToEdit?.length && <Grid item>
            <ActivityTypesField
                label="Filter by activity..."
                onChange={(val, metadata) => onFilter('activityId', val, metadata || {})}
                value={filters?.activityId?.jsonValue}
                includeBundles
            />
        </Grid>}
        <Grid item>
            {
                filteredData?.map(rule => <Rule key={rule.id || rule.tempId} rule={rule} onCancel={onCancel} clientLots={clientLots} />)
            }
            {!(!!filteredData?.length) && <EmptyPlaceholder text="No Rules Defined" />}
        </Grid>

    </Grid>
}
export default LotMechanicalConfig;
